<script>
    /* Copyright (c) 2020-2022 Jacques Desodt */
    export let args = {};

    /* Local variables */
    let style;
    $: style = args.bgColor ? 'background-color:' + args.bgColor + ';' : '';

</script>

<div class="_tp-center" style={style}></div>

<style>._tp-center{border-radius:50%;height:6px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:6px}</style>
